var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"mx-auto mt-2",attrs:{"width":"120","height":"50","contain":"","src":require("@/assets/deco/popup-top-logo.png")}}),_c('p',{staticClass:"text-center font-danjunghae",staticStyle:{"font-size":"30px","line-height":"34px"},style:([_vm.warning ? { color: '#92285B' } : { color: '#66546d' }])},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }